import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { AccordionFullTable, AddCircleBlue } from 'components';
import { fundingSourceActions, payrollActions, systemActions } from 'store';
import { fundingSourceServicesInfo } from './constants';
import { FundingSourceModifiersAdd, FundingSourceServiceAdd } from './modals';
import { PermissionList, RolePermission, sortListByKey, useDiagnosisMatchEnabled, useModal } from 'utils';

export const FundingSourceServices = ({}) => {
    const services = useSelector((state) => state.fundingSource.fundingSourceServices);
    const diagnosisMatchEnabled = useDiagnosisMatchEnabled();
    // The table marks services whose diagnosis match is actually enforced (org switch on + service toggle on)
    const servicesForTable = services?.map((service) => ({
        ...service,
        diagnosisMatchRequired: diagnosisMatchEnabled && !!service?.requireDiagnosisMatch && !!service?.diagnosticCodes?.length,
    }));
    // const classes = fundingSourceSingleStyles();
    const globalCredentials = useSelector((state) => state.system.credentials);
    // const fsSource = useSelector((state) => state.fundingSource.fundingSourceItem);
    const serviceChargeRates = useSelector((state) => state.fundingSource.serviceChargeRates);
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    // const [drawerPosition, setDrawerPosition] = useState({ right: false });
    // const [service, setService] = useState({});
    const [currentId, setCurrentId] = useState('');
    const { open } = useModal();

    useEffect(() => {
        dispatch(systemActions.getServices());
    }, []);

    const renderParams = () => {
        const sendInfo = {
            ...info,
        };
        delete sendInfo.page;
        delete sendInfo.activeTab;
        delete sendInfo.limit;
        delete sendInfo.skip;
        return sendInfo;
    };

    const getServices = () => {
        dispatch(fundingSourceActions.getFoundingSourceServiceById(params?.id, { ...renderParams() }));
    };

    useEffect(() => {
        dispatch(payrollActions.getPayCodeGlobal());
        dispatch(systemActions.getCredentialGlobal());
    }, []);

    useEffect(() => {
        getServices();
    }, [info]);

    // useEffect(() => {
    //     if (services && service) {
    //         const newList = services.find((i) => i.id === service.id);
    //         setService(newList);
    //     }
    // }, [services]);

    // const toggleDrawer = (anchor, open) => {
    //     setDrawerPosition({ ...drawerPosition, [anchor]: open });
    // };

    const handleClickButton = (item, name, parent) => {
        if (name === 'editFundingSourseService') {
            open(<FundingSourceServiceAdd info={item} />);
        }
        if (name === 'editChargeRate') {
            open(<FundingSourceModifiersAdd info={item} currentService={parent} credentials={globalCredentials} />);
        }
        if (name === 'changeStatus') {
            setCurrentId(item?.id);
            dispatch(fundingSourceActions.changeFundingModifierStatus(parent?.id, item?.id));
        }
    };

    return (
        <>
            {RolePermission([PermissionList.FS_SERVICE_CREATE?.code]) && (
                <div className="header-action-btn">
                    <AddCircleBlue type="button" text={'Add Service'} handleClick={() => open(<FundingSourceServiceAdd />)} />
                </div>
            )}
            <AccordionFullTable
                handleAccordion={(k, item) => dispatch(fundingSourceActions.getServiceModifier(item?.id))}
                margin={'0'}
                tableInfo={fundingSourceServicesInfo(handleClickButton, serviceChargeRates, open, currentId)}
                list={sortListByKey(servicesForTable, 'serviceTypeId.name', info)}
            />
        </>
    );
};
